import { RECEIVE_JOBS, REQUEST_JOBS } from "../actions/jobs";

function jobs(state = {}, action) {
  switch (action.type) {
    case REQUEST_JOBS:
      return state;
    
    case RECEIVE_JOBS:
      const newJobs = {};
      action.jobs.forEach(elem => {
        newJobs[elem.id] = elem;
      });
      return Object.assign({}, state, newJobs);
    
    default:
      return state;
  }
}

export default jobs;



// WEBPACK FOOTER //
// ./src/reducers/jobs.js